import type { ColorCodingTemplate } from "@models/ColorCoding";

// Fixed, read-only color coding templates.

const WHITE = "#FFFFFF";
const BLACK = "#000000";

export const RQ_SCORE_STAKEHOLDER_PERFORMANCE_ID =
  "rq-score-stakeholder-performance";
export const PROPORTION_PERFORMANCE_SCALE_ID = "proportion-performance-scale";

export const COLOR_CODING_TEMPLATES: ColorCodingTemplate[] = [
  {
    id: RQ_SCORE_STAKEHOLDER_PERFORMANCE_ID,
    displayName: "RQ Score Stakeholder Performance",
    metricType: "mean",
    ranges: [
      {
        label: "Resilient",
        boundaryText: "80+",
        min: 80,
        max: Infinity,
        bgColor: "#00684E",
        textColor: WHITE,
        bold: true,
      },
      {
        label: "Strong",
        boundaryText: "70 - 79",
        min: 70,
        max: 79,
        bgColor: "#00CF9C",
        textColor: WHITE,
        bold: true,
      },
      {
        label: "Fair",
        boundaryText: "60 - 69",
        min: 60,
        max: 69,
        bgColor: "#7F7F7F",
        textColor: WHITE,
        bold: true,
      },
      {
        label: "Weak",
        boundaryText: "50 - 59",
        min: 50,
        max: 59,
        bgColor: "#FF8769",
        textColor: WHITE,
        bold: true,
      },
      {
        label: "Critical",
        boundaryText: "Below 50",
        min: -Infinity,
        max: 49,
        bgColor: "#C00000",
        textColor: WHITE,
        bold: true,
      },
    ],
  },
  {
    id: PROPORTION_PERFORMANCE_SCALE_ID,
    displayName: "Proportion (%) Performance Scale",
    metricType: "proportion",
    ranges: [
      {
        label: "Exceptional",
        boundaryText: "66% +",
        min: 66,
        max: Infinity,
        bgColor: "#227FBA",
        textColor: WHITE,
        bold: false,
      },
      {
        label: "Strong",
        boundaryText: "51% - 65%",
        min: 51,
        max: 65,
        bgColor: "#54AFE8",
        textColor: BLACK,
        bold: false,
      },
      {
        label: "Emerging",
        boundaryText: "34% - 50%",
        min: 34,
        max: 50,
        bgColor: "#ABC9E0",
        textColor: BLACK,
        bold: false,
      },
      {
        label: "Weak",
        boundaryText: "Below 33%",
        min: -Infinity,
        max: 33,
        bgColor: "#B9BFC7",
        textColor: BLACK,
        bold: false,
      },
    ],
  },
];
